import { post, get, retryAjax } from '@/utils/http/http'
import { getToken } from '../../../utils'
import { PERM_GW_URL, TRIAL_URL } from '@/utils/http/baseUrl'
import ConfigModel from '@store/models/config/config.model'
import { getLocal } from '@/utils/utils'

// 查询用户所拥有的权限
export const getUserAuth = data => {
  // const isLocalhost = window.location.hostname.toLowerCase() === 'localhost'
  return retryAjax({
    retryUrl: `${PERM_GW_URL}/v1/user_permission/list_user_permission`,
    requestFn: post,
    // maxCount: isLocalhost ? 1 : 2,
    maxCount: 2,
  })(`${PERM_GW_URL}/v1/user_permission/list_user_permission`, data, false, {
    // timeout: isLocalhost ? 100 : 5000,
    timeout: 5000,
    headers: {
      tenantid: window.zbvd.zbid,
      appcode: 'agent_setting',
      Authorization: `Bearer ${getToken()}`,
    },
  })
}

// 查询门店系统所拥有的权限
export const getStoreAuth = data => {
  // const isLocalhost = window.location.hostname.toLowerCase() === 'localhost'
  return retryAjax({
    retryUrl: `${PERM_GW_URL}/v1/user_permission/list_user_permission`,
    requestFn: post,
    // maxCount: isLocalhost ? 1 : 2,
    maxCount: 2,
  })(`${PERM_GW_URL}/v1/user_permission/list_user_permission`, {}, false, {
    // timeout: isLocalhost ? 100 : 5000,
    timeout: 5000,
    headers: {
      tenantid: window.zbvd.zbid,
      appcode: 'store_setting',
      rolecode: data.rolecode,
      Authorization: getLocal(ConfigModel.TOKEN_KEY),
    },
  })
}
// 获取灰度直播间资格
export const getAgentGray = params =>
  get(`${TRIAL_URL}/v1/is_trial/perm_agent_setting`, params, false)
